module.exports = __webpack_public_path__ + "static/img/device-2.8537f8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/device-2.png
// module id = gqIJ
// module chunks = 0